export const SET_SEARCH_CITIES = "SET_SEARCH_CITIES";
export const REMOVE_SEARCH_CITIES = "REMOVE_SEARCH_CITIES";
export const SET_SEARCH_CITIES_LOADER = "SET_SEARCH_CITIES_LOADER";
export const SEARCH_CITIES = "SEARCH_CITIES";
export const FETCH_CITY_AIRPORT_DICTIONARIES = "SET_CITY_AIRPORT_DICTIONARIES";
export const SET_CITY_AIRPORT_DICTIONARIES = "SET_CITY_AIRPORT_DICTIONARIES";
export const REMOVE_CITY_AIRPORT_DICTIONARIES =
  "REMOVE_CITY_AIRPORT_DICTIONARIES";
